import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const heApi = {
  async getEquipmentTypeList(param: any) {
    return await authInstance
      .get(`/he/setting/typeList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getTypeList(param?: any) {
    return await authInstance
      .get(`/he/setting/code/type?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveType(param: any) {
    return await authInstance.post(`/he/setting/saveType`, param).then((res) => res.data);
  },
  async deleteAllType(param: any) {
    return await authInstance.post(`/he/setting/deleteAllType`, param).then((res) => res.data);
  },
  async getEquipmentType(param: any) {
    return await authInstance
      .get(`/he/setting/type?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getTrainingList(param: any) {
    return await authInstance
      .get(`/he/setting/trainingList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getTraining(param: any) {
    return await authInstance
      .get(`/he/setting/training?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getManageTraining(param: any) {
    return await authInstance
      .get(`/he/setting/manage/training?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveTraining(param: any) {
    return await authInstance
      .post(`/he/setting/saveTraining`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async deleteAllTraining(param: any) {
    return await authInstance.post(`/he/setting/deleteAllTraining`, param).then((res) => res.data);
  },
  async copyTraining(param: any) {
    return await authInstance.post(`/he/setting/copy/training`, param).then((res) => res.data);
  },
  async saveTemplateOrder(param: any) {
    return await authInstance.post(`/he/setting/saveTemplateOrder`, param).then((res) => res.data);
  },
  async saveTrainingOrder(param: any) {
    return await authInstance.post(`/he/setting/saveTrainingOrder`, param).then((res) => res.data);
  },
  async getTemplateList(param: any) {
    return await authInstance
      .get(`/he/setting/templateList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getTemplateCodeList(param?: any) {
    return await authInstance
      .get(`/he/setting/code/template?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getTemplate(param: any) {
    return await authInstance
      .get(`/he/setting/template?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveTemplate(param: any) {
    return await authInstance
      .post(`/he/setting/saveTemplate`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async deleteAllTemplate(param: any) {
    return await authInstance.post(`/he/setting/deleteAllTemplate`, param).then((res) => res.data);
  },
  async copyType(param: any) {
    return await authInstance.post(`/he/setting/copy/type`, param).then((res) => res.data);
  },
  async copyTemplate(param: any) {
    return await authInstance.post(`/he/setting/copy/template`, param).then((res) => res.data);
  },
  async getEquipmentList(param: any) {
    return await authInstance.get(`/he/page/list?${qs.stringify(param)}`).then((res) => res.data);
  },
  async getEquipmentCount(param: any) {
    return await authInstance.get(`/he/page/count?${qs.stringify(param)}`).then((res) => res.data);
  },
  async getEquipmentExcelData(param: any) {
    return await authInstance.get(`/he/page/excel?${qs.stringify(param)}`).then((res) => res.data);
  },
  async getEquipmentExcelList(param: any) {
    return await authInstance
      .get(`/he/page/excelList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async updateTemplateUse(param: { templateSeq: any; isUse: boolean }) {
    return await authInstance.post(`/he/setting/template/use`, param).then((res) => res.data);
  },
  async updateTrainingUse(param: { safetySeq: any; isUse: boolean; equipmentTypeId?: any }) {
    return await authInstance.post(`/he/setting/training/use`, param).then((res) => res.data);
  },
  async deleteAllEquipment(param: any) {
    return await authInstance.post(`/he/page/deleteAll`, param).then((res) => res.data);
  },
  async saveEquipment(param: any) {
    return await authInstance
      .post(`/he/page/save`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async saveInspection(param: any) {
    return await authInstance
      .post(`/he/page/saveInspection`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async saveSafetyTraining(param: any) {
    return await authInstance.post(`/he/page/saveSafetyTraining`, param).then((res) => res.data);
  },
  async saveOutbound(param: any) {
    return await authInstance.post(`/he/page/saveOutbound`, param).then((res) => res.data);
  },
  async saveApproval(param: any) {
    return await authInstance.post(`/he/page/saveApproval`, param).then((res) => res.data);
  },
  async getApprovalList(param: any) {
    return await authInstance
      .get(`/he/page/approvalList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getEquipmentDetail(param: any) {
    return await authInstance
      .get(`/he/page/getEquipment?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getApprovalHistory(param: any) {
    return await authInstance
      .get(`/he/page/approvalHistory?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getInspectionHistory(param: any) {
    return await authInstance
      .get(`/he/page/inspectionHistory?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getInspect(param: any) {
    return await authInstance
      .get(`/he/page/getInspect?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getApproval(param: any) {
    return await authInstance
      .get(`/he/page/approval?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveInspectionRequest(param: any) {
    return await authInstance.post(`/he/page/saveInspectionRequest`, param).then((res) => res.data);
  },
  async saveInspectionApproval(param: any) {
    return await authInstance
      .post(`/he/page/saveInspectionApproval`, param)
      .then((res) => res.data);
  },
  async getRentalHistory(param: any) {
    return await authInstance
      .get(`/he/page/rentalHistory?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getRental(param: any) {
    return await authInstance
      .get(`/he/page/getRental?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveRental(param: any) {
    return await authInstance.post(`/he/page/saveRental`, param).then((res) => res.data);
  },
  async saveReturn(param: any) {
    return await authInstance.post(`/he/page/saveReturn`, param).then((res) => res.data);
  },
  async saveApprovalSign(param: any) {
    return await authInstance.post(`/he/page/saveApprovalSign`, param).then((res) => res.data);
  },
  async downloadFile(fileId: string, originalName?: string) {
    const response = await authInstance.get(`/he/file/downloads/${fileId}`, {
      responseType: 'blob'
    });
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = originalName || 'download';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
  async getFileBlobUrl(fileId: string): Promise<string> {
    const response = await authInstance.get(`/he/file/downloads/${fileId}`, {
      responseType: 'blob'
    });
    const contentType = response.headers['content-type'] || 'application/octet-stream';
    return window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
  }
};
